export default (block) => {
  return {
    description: block.video.name || '',
    video: block.video.filename,
    placeholder: block.placeholder.filename
  }
}
